import styled, { createGlobalStyle, css } from 'styled-components'
import { containerDefault } from '../../../lib/styles/Container'
import CustomLink from '../../CustomLink'

export const GlobalVariableStyle = createGlobalStyle`
  :root {
    --nav-height: 4.8rem;

    @media screen and (max-width: 1080px) {
      --nav-height: 3.5rem;
    }
  }
`

export const StyledWrapper = styled.div<{
  isScrolled?: boolean
}>`
  background-color: ${({ theme }) => theme.colors.white[1]};
  gap: 2rem;
  transition: box-shadow 0.32s;
  z-index: 102;

  @media screen and (max-width: 1080px) {
    display: none;
  }
`

export const ContainerInner = styled.div`
  ${containerDefault}
  align-items: center;
  display: flex;
  height: var(--nav-height);
  margin-inline: auto;
  padding: 1.5rem 0;
`

export const StyledItems = styled.div<{
  right?: boolean
}>`
  align-items: center;
  display: flex;
  gap: 1rem;

  ${p =>
    p.right &&
    css`
      margin-left: auto;
    `}
`

export const StyledLogoLink = styled(CustomLink)`
  display: block;
`

export const StyledLogo = styled.img`
  display: block;
  height: 1.6rem;
`

export const StyledNav = styled.ul`
  align-items: center;
  display: flex;
  margin: 0;
  padding: 0;
  gap: 0.25rem;
`

export const StyledDropdownBackdrop = styled.div<{ active?: boolean }>`
  background-color: ${({ theme }) => theme.colors.white[1]};
  bottom: 0;
  left: 0;
  opacity: ${p => (p.active ? '.8' : '0')};
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 0.25s, visibility 0.25s;
  transition-delay: ${p => (p.active ? '.25s' : '0')};
  visibility: ${p => (p.active ? 'visible' : 'hidden')};
  z-index: 1;
`
